import { Directive, Input, OnInit, Renderer2, ViewContainerRef } from '@angular/core';

/**
 * This directive removes the paginator control from twc component. We don't need it
 */
@Directive({
    selector: '[cwHideListFilesControl]',
    standalone: false,
})
export class HideListFilesControlDirective implements OnInit {
    @Input() cwHideListFiles = false;
    constructor(
        private renderer: Renderer2,
        private viewContainer: ViewContainerRef
    ) {}

    ngOnInit(): void {
        if (!this.cwHideListFiles) {
            return;
        }
        const listContent = this.viewContainer.element.nativeElement.querySelector('.twc-input-file-list');
        if (listContent) {
            this.renderer.setStyle(listContent, 'display', 'none');
        }
    }
}
